module.exports = __webpack_public_path__ + "static/media/goodbye-stress.ece6caf4.jpg";